import * as ACTIONTYPE from '../constants/actiontypes'

const _default = {
  token: null,
  apiKey: null,
  userKey: null,
  resolution: 720,
  isResolutionPopupOpened: false,
  isWidget: null,
  isWidgetBooks: null,
  isWidgetChannel: null,
  widgetChannel: 1,
  isWidgetSubs: null,
  isWidgetUser: null,
  parentSelector: '#root',
  playbackRate: 1,
};

export default function (state = _default, action) {
  switch (action.type) {
    case ACTIONTYPE.PERSIST_TOKEN:
      return { ...state, token: action.token };
    case ACTIONTYPE.PERSIST_API_KEY:
      return { ...state, apiKey: action.apiKey, userKey: action.userKey };
    case ACTIONTYPE.SET_PARENT_SELECTOR:
      return {...state, parentSelector: action.selector}

    case ACTIONTYPE.PERSIST_WIDGET:
      return {
        ...state,
        isWidget: action.isWidget,
        isWidgetBooks: action.isWidgetBooks,
        isWidgetChannel: action.isWidgetChannel,
        isWidgetSubs: action.isWidgetSubs,
        isWidgetUser: action.isWidgetUser
      };
    case ACTIONTYPE.PERSIST_WIDGET_CHANNEL:
      return {
        ...state,
        widgetChannel: action.widgetChannel,
      };

    case ACTIONTYPE.CHANGE_VIDEO_RESOLUTION:
      if ([2160, 1080, 720, 480].indexOf(action.resolution) !== -1) {
        return { ...state, resolution: action.resolution };
      }
      break;
    case ACTIONTYPE.CHANGE_PLAYBACK_RATE:
      return { ...state, playbackRate: action.playbackRate };

    case ACTIONTYPE.CONTROLS_HIDE:
      if (!action.visibility) {
        return {
          ...state,
          isResolutionPopupOpened: false
        };
      } else {
        return state;
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/AppReducer.js